/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { configsSelector } from '../../store/reducers/servicesConfigs';
import {
  getAgentData,
  loadingAgentsDataSelector,
} from '../../store/reducers/agentsData';
import {
  makePrediction,
  makePredictions,
} from '../../store/actions/predictions';
import { getModelData, getSamplesData } from '../../store/actions/agentsData';
import { getSettings, setSettings } from '../../store/actions/settings';
import {
  agentVersionSelector,
  settingsSelector,
} from '../../store/reducers/settings';
import * as Service from '../../server/RestClients';
import { flagsSelector } from '../../store/reducers/flags';

const cameraNotFound =
  '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';

const useStyles = makeStyles((theme) => ({
  select: {
    margin: theme.spacing(2),
    minWidth: 300,
  },
  tableContainer: {
    border: '0.1em solid grey',
    borderRadius: 0,
  },
  tablePropertyCell: {
    borderRight: '0.1em solid grey',
    padding: '0.5em',
    width: '40%',
  },
  enableVideo: {
    color: 'white',
    height: '100%',
    paddingTop: '20%',
    textAlign: 'center',
    backgroundImage: `url("data:image/png;base64,${cameraNotFound}")`,
    backgroundPosition: 'center',
    boxShadow: 'inset 0 0 0 1000px rgba(0,0,0,.7)',
  },
  button: {
    backgroundColor: '#2ca0f7',
    color: 'white',
    textTransform: 'none',
    fontFamily: 'Exo 2',
    fontSize: '.5em',
    marginLeft: theme.spacing(1),
    height: '3em',
    width: '9em',
    borderRadius: '5px',
    border: 'none',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#e0e0e0',
    },
  },
}));

export default () => {
  const classes = useStyles();
  const [currentConfig, setCurrentConfig] = useState(0);
  const configs = useSelector(configsSelector);
  const agentVersion = useSelector(agentVersionSelector);
  const settings = useSelector(settingsSelector);
  const videoStreamEnabled = settings?.VideoStream?.enabled ?? false;

  const loading = useSelector((state) => loadingAgentsDataSelector(state));
  const [showCrosshair, setShowCrosshair] = useState(false);
  const [runPrediction, setRunPrediction] = useState(true);
  const [enableVideoBtnClicked, setEnableVideoBtnClicked] = useState(false);

  const config = configs[currentConfig];
  const agentData = useSelector((state) => getAgentData(state, config));
  const flags = useSelector(flagsSelector);
  const configOptions = configs.map(({ host, port }) => `${host}:${port}`);
  const prediction = useSelector(
    (state) => state.predictions.predictions[currentConfig] ?? {}
  );

  const {
    response,
    // eslint-disable-next-line no-unused-vars
    error,
    // eslint-disable-next-line no-unused-vars
    request,
    _duration,
    // eslint-disable-next-line no-unused-vars
    _options,
  } = prediction;

  const {
    uuid,
    predictions: predictionsList,
    image,
    duration,
    capture_duration: captureDuration,
  } = response ?? {};
  const captureDurationCalc =
    duration && _duration ? _duration - duration : undefined;
  const renderMs = (n) =>
    typeof n === 'number' ? `${n.toFixed(2)} ms` : n ?? `-Not Available-`;
  const predictionDetails = [
    ...(captureDuration !== undefined
      ? [{ title: 'Capture duration', value: renderMs(captureDuration) }]
      : []),
    ...(captureDurationCalc !== undefined && captureDuration === undefined
      ? [
          {
            title: 'Capture duration (calc)',
            value: renderMs(captureDurationCalc),
          },
        ]
      : []),
    ...(duration !== undefined
      ? [{ title: 'Prediction duration', value: renderMs(duration) }]
      : []),
    ...(_duration !== undefined
      ? [{ title: 'Total request duration', value: renderMs(_duration) }]
      : []),
    { title: 'UUID', value: uuid },
  ];

  const properties = [
    { property: 'Model version', value: agentData.model_id },
    {
      property: 'Model deployed on',
      value: agentData.created_at
        ? moment(agentData.created_at).format('DD/MM/YYYY HH:mm:ss')
        : '',
    },
    { property: 'Agent version', value: agentVersion },
    { property: 'Total samples', value: agentData.totalSamples },
    { property: 'Total labels', value: agentData.totalLabels },
  ];

  const dispatch = useDispatch();

  const setShowCrosshairWrapper = (event) => {
    setShowCrosshair(event.target.checked);
  };

  const setRunPredictionWrapper = (event) => {
    setRunPrediction(event.target.checked);
  };

  const onConfigChange = ({ target }) => {
    setCurrentConfig(target.value);
  };

  const onCapture = () => {
    dispatch(
      makePrediction(config, currentConfig, { _predict: runPrediction }, flags)
    );
  };

  const onEnableVideoStream = () => {
    const s = JSON.parse(JSON.stringify(settings));
    s.VideoStream.enabled = true;
    dispatch(setSettings(config, s));
  };

  const handleCaptureImg = async () => {
    await dispatch(makePredictions({ _predict: runPrediction }, flags));
    setTimeout(() => {
      setEnableVideoBtnClicked(false);
    }, 4000);
  };

  const handleEnableVideo = () => {
    setEnableVideoBtnClicked(true);
    onEnableVideoStream();
    setTimeout(() => {
      handleCaptureImg();
    }, 2000);
  };

  const handleRestartAgent = async () => {
    await Service.restartAgent(config);
  };

  useEffect(() => {
    if (videoStreamEnabled && !enableVideoBtnClicked) {
      setTimeout(() => {
        dispatch(makePredictions({ _predict: runPrediction }, flags));
      }, 300);
    }
  }, [videoStreamEnabled]);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.keyCode === 16 && !loading) {
        onCapture();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  useEffect(() => {
    dispatch(getModelData(config));
  }, [config]);

  useEffect(() => {
    dispatch(getSamplesData(config, {}, flags));
  }, [config, flags]);

  useEffect(() => {
    dispatch(getSettings(config));
  }, [config]);

  return {
    ...config,
    loading,
    classes,
    configOptions,
    currentConfig,
    image,
    predictionDetails,
    predictionsList,
    properties,
    onCapture,
    onConfigChange,
    showCrosshair,
    setShowCrosshairWrapper,
    videoStreamEnabled,
    onEnableVideoStream,
    handleEnableVideo,
    enableVideoBtnClicked,
    handleRestartAgent,
    runPrediction,
    setRunPredictionWrapper,
  };
};
